import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PURGE } from 'redux-persist';
import { push } from 'connected-react-router'
import { makeStyles } from '@material-ui/core/styles';
import SettingsIcon from '@material-ui/icons/Settings';
import ExitIcon from '@material-ui/icons/ExitToApp';
import { 
    List, 
    ListItem, 
    ListItemIcon, 
    ListItemText, 
    IconButton, 
    Popper, 
    ClickAwayListener, 
    Dialog, 
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from '@material-ui/core';
import UserListItem from './user-list-item'
import UserAvatar from './user-avatar'
import ExirioStyles from '../../utils/exirioStyles'
import { logoutApiAction } from '../../modules/actions/logout';
import {axios, getToken} from "../../settings";
import { isTokenPresent } from '../../utils/util';
import { useSnackbar } from 'notistack';


const useStyles = makeStyles((theme) => ({
    popper: {
        backgroundColor: ExirioStyles.modalWindows,
        borderRadius: '4px',
        width: '300px',
        color: ExirioStyles.secondaryWhiteText,
        marginTop: '8px',
        zIndex: 9999,
        '&[x-placement*="bottom"] $arrow': {
            top: 0,
            left: 0,
            marginTop: '-1.5em',
            width: '4em',
            height: '1em',
            '&::before': {
                borderWidth: '0 2em 2em 2em',
                borderColor: `transparent transparent ${ExirioStyles.modalWindows} transparent`,
            },
        },
    },
    arrow: {
        position: 'absolute',
        fontSize: 7,
        width: '4em',
        height: '4em',
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: 0,
            height: 0,
            borderStyle: 'solid',
        },
    },
    listUser: {
        maxHeight: '400px',
        overflow: 'auto'
    },
    pureWhiteText: {
        color: ExirioStyles.pureWhiteText,
    },
    avatar: {
        width: theme.spacing(4),
        height: theme.spacing(4),
        color: ExirioStyles.pureWhiteText,
    },
    divider: {
        borderBottom: `1px solid ${ExirioStyles.tableTint}`
    },
    holderLabel: {
        padding: '15px 10px 5px 58px',
        fontSize: '16px'
    },
    iconAvatar: {
        width: '32px',
        justifyContent: 'center',
        color: ExirioStyles.pureWhiteText,
    },
}));

export default function ProfileMenu() {
    const { currentUser, ownerUser } = useSelector(state => ({
        currentUser: state.global.currentUser,
        ownerUser: state.global.ownerUser
    }))
    const dispatch = useDispatch()
    const [anchorEl, setAnchorEl] = useState(null);
    const [arrowRef, setArrowRef] = useState(null);
    const [userProfile, setUserProfile] = useState({});
    const [openAlert, setOpenAlert] = useState(false);
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (ownerUser && 
                (ownerUser.viewDenied || 
                (ownerUser.permission && !ownerUser.permission.edit && !ownerUser.permission.View))) {
            return changeUser(currentUser);
        }
        setUserProfile(ownerUser || currentUser || {});
    }, [ownerUser, currentUser]);

    const isActiveUser = (user) => {
        return user?.email === userProfile?.email;
    }

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(anchorEl ? null : event.currentTarget);
    }

    const closeMenu = () => {
        setAnchorEl(null);
    }

    const popperOpen = Boolean(anchorEl);

    const popperId = popperOpen ? 'profile-menu-popper' : undefined;

    const changeUser = async (user) => {
        closeMenu();
        if (!(await userCanAccess(user))) {
            return setOpenAlert(true);
        }
        setUserProfile(user);
        // Reset dashboard
        dispatch({ type: 'SET_ASSET_LIST', payload: [] });

        // Set owner user
        if (currentUser && (currentUser.email === user.email)) {
            user = null;
        }
        localStorage.setItem('ownerUser', JSON.stringify(user));
        dispatch({ type: 'SET_OWNER_USER', user });
        setTimeout(() => {
            localStorage.setItem("rememberMeAdmin", true);
            window.location.assign('/');
        }, 500);
    }

    const logout = async () => {
        await logoutApiAction()
        dispatch({ type: 'LOGOUT' });
        dispatch({
            type: PURGE,
            result: () => null
        });
        localStorage.clear();
        sessionStorage.clear()
        dispatch(push('/login'))
    }

    const onUserSetting = () => {
        dispatch(push('/setting'));
        closeMenu();
    }

    const userCanAccess = async (user) => {
        if (!user.permission) {
            return true;
        }
        return user.permission.edit || user.permission.View;
    }

    // Try get data to ensure that can access to User's information

    const handleCloseAlert = () => {
        setOpenAlert(false);
        
    }

    const alertAccessWithoutRights = () => (
        <Dialog 
            open={openAlert}
            onClose={handleCloseAlert}
            maxWidth={'xs'}
            aria-labelledby="alert-title"
            aria-describedby="alert-description"
        >
            <DialogTitle id="alert-title">Access denied</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-description">
                    You don't have access to this User's information.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseAlert} color="primary" autoFocus>OK</Button>
            </DialogActions>
        </Dialog>
    );

    return (
        <div>
            <ClickAwayListener onClickAway={closeMenu}>
                <div>
                    <IconButton aria-describedby={popperId} onClick={handleClick} style={{ padding: '8px' }}>
                        <UserAvatar user={userProfile} className={classes.avatar} />
                    </IconButton>
                    <Popper id={popperId} 
                            open={popperOpen} 
                            anchorEl={anchorEl} 
                            placement={'bottom-end'} 
                            modifiers={{
                                arrow: {
                                    enabled: true,
                                    element: arrowRef,
                                },
                            }}
                            className={classes.popper}>
                        <span className={classes.arrow} ref={setArrowRef} />
                        <List className={classes.listUser}>
                            <UserListItem user={currentUser} isActive={isActiveUser(currentUser)} onChange={changeUser} isCurrentUser={true}></UserListItem>
                            
                            <div className={classes.divider}></div>
                            <ListItem button onClick={logout}>
                                <ListItemIcon className={classes.iconAvatar}>
                                    <ExitIcon />
                                </ListItemIcon>
                                <ListItemText className={classes.pureWhiteText} primary="Log out" />
                            </ListItem>
                        </List>
                    </Popper>
                </div>
            </ClickAwayListener>
            {alertAccessWithoutRights()}
            
        </div>
    );
}
